<template>
  <el-form
    label-width="100px"
    :model="form"
    :disabled="disabled"
  >
    <el-row>
      <el-col :span="14">
        <el-form-item label="歌曲上架状态">
          <el-radio-group v-model="form.statusList" @change="search">
            <el-radio-button
              v-for="(item,i) in storedStatusOption"
              :key="i"
              :label="item[0]"
            >
              {{ item[1] }}
            </el-radio-button>
          </el-radio-group>
          <el-tooltip content="当歌曲状态为隐藏时，歌曲将暂缓结算，请联系相关商务核对处理" placement="top">
            <i class="el-icon-info" />
          </el-tooltip>
        </el-form-item>
      </el-col>

      <el-col :span="10">
        <el-form-item label="隐藏原因">
          <el-select v-model="form.hideReasonList" placeholder="请选择隐藏原因" clearable @change="search">
            <el-option
              v-for="(val,text) in hiddenReasonToOuterOption"
              clearable
              :key="text"
              :label="text"
              :value="val"
            >
            </el-option>
          </el-select>
        </el-form-item>
      </el-col>
    </el-row>

    <el-row>
      <el-col :span="14">
        <el-form-item label="歌曲付费口径">
          <el-checkbox-group v-model="form.paymentTypeList" @change="search">
            <el-checkbox-button v-for="(name, id) in paymentTypeMap" :key="+id" :label="+id">{{ name }}</el-checkbox-button>
          </el-checkbox-group>
        </el-form-item>
      </el-col>

      <el-col :span="10">
        <el-form-item label="上架时间">
          <el-date-picker
            @change="search"
            v-model="form.publicTimeDate"
            type="daterange"
            value-format="yyyy-MM-dd HH:mm:ss"
            align="right"
            unlink-panels
            range-separator="~"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            style="width:100%"
            :picker-options="pickerOptions"
          ></el-date-picker>
        </el-form-item>
      </el-col>

      <el-col :span="8">
        <el-form-item label="录音版权瑕疵">
          <el-select
            v-model="form.cpDefectList"
            placeholder="全部"
            filterable
            multiple
            collapse-tags
            clearable
            style="width:100%"
          >
            <el-option v-for="(name, id) in cpDefectMap" :key="id" :label="name" :value="+id"></el-option>
          </el-select>
        </el-form-item>
      </el-col>
      <el-col :span="8">
        <el-form-item label="词版权瑕疵">
          <el-select
            v-model="form.wordCpDefectList"
            placeholder="全部"
            filterable
            multiple
            collapse-tags
            clearable
            style="width:100%"
          >
            <el-option v-for="(name, id) in cpDefectMap" :key="id" :label="name" :value="+id"></el-option>
          </el-select>
        </el-form-item>
      </el-col>
      <el-col :span="8">
        <el-form-item label="曲版权瑕疵">
          <el-select
            v-model="form.musicCpDefectList"
            placeholder="全部"
            filterable
            multiple
            collapse-tags
            clearable
            style="width:100%"
          >
            <el-option v-for="(name, id) in cpDefectMap" :key="id" :label="name" :value="+id"></el-option>
          </el-select>
        </el-form-item>
      </el-col>

      <el-col :span="8">
        <el-form-item label="歌手名">
          <el-input placeholder="精确查询" @keyup.enter.native="search" v-model.trim="form.singerName"></el-input>
        </el-form-item>
      </el-col>

      <el-col :span="8">
        <el-form-item label="专辑名">
          <el-input placeholder="模糊查询" @keyup.enter.native="search" v-model.trim="form.albumName__icontains"></el-input>
        </el-form-item>
      </el-col>

      <el-col :span="8">
        <el-form-item label="录音合同号">
          <el-input placeholder="请输入录音合同号" @keyup.enter.native="search" v-model.trim="form.contract"></el-input>
        </el-form-item>
      </el-col>

      <el-col :span="24">
        <el-form-item>
          <p class="collapse-tip" @click="showCollapse = !showCollapse">
            {{ collapseTip }}
            <i class="el-icon-arrow-down" :class="showCollapse ? 'transfrom' : ''" />
          </p>
        </el-form-item>
      </el-col>
    </el-row>

    <div class="hide-form" :style="{ height: showCollapse ? 'auto' : '0' }">
      <el-form-item label="歌曲ID (TME ID)" label-width="120px">
        <multiple-input
          type="textarea"
          :rows="2"
          v-model="form.trackIdList"
          placeholder="多个以逗号分隔"
          formatter="number"
          clearable
        ></multiple-input>
      </el-form-item>

      <div class="search-extra-from">
        <section class="item">
          <p class="tit">歌曲信息</p>
          <el-form-item label="歌曲ISRC">
            <el-input placeholder="请输入ISRC" @keyup.enter.native="search" v-model.trim="form.isrc"></el-input>
          </el-form-item>

          <el-form-item label="专辑UPC">
            <el-input placeholder="请输入UPC" @keyup.enter.native="search" v-model.trim="form.upc"></el-input>
          </el-form-item>
        </section>
        <section class="item">
          <p class="tit">录音版权信息</p>
          <el-form-item label="授权时间">
            <el-date-picker
              @change="search"
              v-model="form.copyrightDate"
              type="daterange"
              value-format="yyyy-MM-dd HH:mm:ss"
              align="right"
              unlink-panels
              range-separator="~"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              style="width:100%"
              :picker-options="pickerOptions"
            ></el-date-picker>
          </el-form-item>

          <el-form-item label="是否代理">
            <el-radio-group v-model="form.isAgent" @change="search">
              <el-radio v-for="(name, id) in switchMap" :key="+id" :label="+id">{{ name }}</el-radio>
            </el-radio-group>
          </el-form-item>
        </section>
        <section class="item">
          <p class="tit">词版权信息</p>
          <el-form-item label="词作者">
            <el-input placeholder="请输入词作者" @keyup.enter.native="search" v-model.trim="form.wordAuthor"></el-input>
          </el-form-item>

          <el-form-item label="授权时间">
            <el-date-picker
              @change="search"
              v-model="form.wordCopyrightDate"
              type="daterange"
              value-format="yyyy-MM-dd HH:mm:ss"
              align="right"
              unlink-panels
              range-separator="~"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              style="width:100%"
              :picker-options="pickerOptions"
            ></el-date-picker>
          </el-form-item>

          <el-form-item label="是否代理">
            <el-radio-group v-model="form.wordIsAgent" @change="search">
              <el-radio v-for="(name, id) in switchMap" :key="+id" :label="+id">{{ name }}</el-radio>
            </el-radio-group>
          </el-form-item>

          <el-form-item label="是否翻唱">
            <el-radio-group v-model="form.wordCpSource" @change="search">
              <el-radio v-for="(name, id) in switchMap" :key="+id" :label="+id">{{ name }}</el-radio>
            </el-radio-group>
          </el-form-item>
        </section>
        <section class="item">
          <p class="tit">曲版权信息</p>
          <el-form-item label="曲作者">
            <el-input placeholder="请输入曲作者" @keyup.enter.native="search" v-model.trim="form.musicAuthor"></el-input>
          </el-form-item>

          <el-form-item label="授权时间">
            <el-date-picker
              @change="search"
              v-model="form.musicCopyrightDate"
              type="daterange"
              value-format="yyyy-MM-dd HH:mm:ss"
              align="right"
              unlink-panels
              range-separator="~"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              style="width:100%"
              :picker-options="pickerOptions"
            ></el-date-picker>
          </el-form-item>

          <el-form-item label="是否代理">
            <el-radio-group v-model="form.musicIsAgent" @change="search">
              <el-radio v-for="(name, id) in switchMap" :key="+id" :label="+id">{{ name }}</el-radio>
            </el-radio-group>
          </el-form-item>

          <el-form-item label="是否翻唱">
            <el-radio-group v-model="form.musicCpSource" @change="search">
              <el-radio v-for="(name, id) in switchMap" :key="+id" :label="+id">{{ name }}</el-radio>
            </el-radio-group>
          </el-form-item>
        </section>
      </div>
    </div>
  </el-form>
</template>

<script>
import { cloneDeep, isEmpty } from 'lodash-es'
import {
  storedStatusOption,
  switchMap,
  cpDefectMap,
  hiddenReasonToOuterOption
} from '@/utils/constants'
import { paymentTypeMap } from '@/views/album/mixin'
import MultipleInput from '@/components/MultipleInput'

const Unf = undefined

function defaultForm() {
  return {
    // 默认展示筛选条件
    statusList: [0, 1],
    hideReasonList: Unf,
    paymentTypeList: [],
    publicTimeDate: [],
    cpPercentSign: Unf,
    wordCpPercentSign: Unf,
    musicCpPercentSign: Unf,

    // 隐藏
    trackId: Unf,
    trackIdList: [],
    // 歌曲信息
    singerName: '',
    albumName__icontains: '',
    contract: '',
    isrc: '',
    upc: '',

    // 录音版权信息
    copyrightDate: [],
    cpDefectList: [],
    isAgent: Unf,
    cpSource: Unf,

    // 词版权信息
    wordAuthor: '',
    wordCopyrightDate: [],
    wordCpDefectList: [],
    wordIsAgent: Unf,
    wordCpSource: Unf,

    // 曲版权信息
    musicAuthor: '',
    musicCopyrightDate: [],
    musicCpDefectList: [],
    musicIsAgent: Unf,
    musicCpSource: Unf,
  }
}

const hideSearchKeys = [
  'trackId',
  'trackIdList',
  'singerName',
  'albumName__icontains',
  'contract',
  'isrc',
  'upc',
  'copyrightDate',
  'cpDefectList',
  'isAgent',
  'cpSource',
  'wordAuthor',
  'wordCpDefectList',
  'wordIsAgent',
  'wordCpSource',
  'musicAuthor',
  'musicCpDefectList',
  'musicIsAgent',
  'musicCpSource'
]

export default {
  name: 'StoredSearchFrom',
  components: {
    MultipleInput,
  },
  props: {
    disabled: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      storedStatusOption,
      paymentTypeMap,
      switchMap,
      hiddenReasonToOuterOption,
      cpDefectMap,

      showCollapse: false,

      form: defaultForm(),

      pickerOptions: {
        shortcuts: [{
          text: '最近一周',
          onClick(picker) {
            const end = new Date()
            const start = new Date()
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 7)
            picker.$emit('pick', [start, end])
          }
        }, {
          text: '最近一个月',
          onClick(picker) {
            const end = new Date()
            const start = new Date()
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 30)
            picker.$emit('pick', [start, end])
          }
        }, {
          text: '最近三个月',
          onClick(picker) {
            const end = new Date()
            const start = new Date()
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 90)
            picker.$emit('pick', [start, end])
          }
        }]
      },
    }
  },

  computed: {
    formatForm() {
      const params = cloneDeep(this.form)
      // 处理时间
      const dateKeys = ['publicTimeDate', 'copyrightDate', 'wordCopyrightDate', 'musicCopyrightDate']
      for (const key of dateKeys) {
        const dates = params[key] || []
        if (dates.length) {
          const fromKey = key.replace('Date', 'From')
          const toKey = key.replace('Date', 'To')
          ;[params[fromKey], params[toKey]] = dates
        }
        Reflect.deleteProperty(params, key)
      }

      // 移除不合法的条件：空字符串、空数组、undefined、null
      Object.keys(params).forEach(key => {
        const val = params[key]

        // eslint-disable-next-line eqeqeq
        if (val == undefined || val === '' || (Array.isArray(val) && !val.length)) {
          Reflect.deleteProperty(params, key)
        }
      })

      return params
    },
    collapseTip() {
      return this.showCollapse ? '收起全部' : '更多筛选条件'
    }
  },

  methods: {
    handleReset() {
      this.form = defaultForm()
    },
    initData(data) {
      for (const key in data) {
        if (this.form.hasOwnProperty(key) && !isEmpty(data[key])) {
          this.form[key] = data[key]
          if (hideSearchKeys.includes(key)) {
            this.showCollapse = true
          }
        }
      }
    },
    search() {
      this.$emit('search')
    }
  },
}
</script>

<style lang="scss" scoped>
.el-icon-info{
  font-size: 16px;
  margin-left: 4px;
  vertical-align: middle;
}

.collapse-tip {
  margin-top: 1px;
  margin-right: 5px;
  float: right;
  color: #4071ff;
  cursor: pointer;
  font-size: 12px;

  i {
    transition: all 0.3s linear;
    &.transfrom {
      transform: rotate(180deg);
    }
  }
}

.hide-form {
  overflow: hidden;
  transition: all .3s linear;
}

.search-extra-from {
  display: flex;
  margin-bottom: 8px;
  .item {
    width: 25%;
    padding: 5px 4px;
    margin: 0 8px;
    border-radius: 4px;
    border: 1px dashed #cfd0cf;
    background-color: #f2f2f2;

    .tit {
      font-size: 14px;
      font-weight: bold;
      margin: 0px 10px 5px 10px;
    }
  }

  ::v-deep {
    .el-checkbox {
      margin-right: 20px;
    }

    .el-checkbox__label {
      padding-left: 5px;
    }
  }
}

::v-deep {
   .el-form-item--mini.el-form-item{
       margin-bottom: 14px;
    }
}
</style>
